<template>
    <div>
        <NavBar></NavBar>
        <div class="row">
            <MarketWatch class="col-md-4 d-none d-md-block"></MarketWatch>
            <div class="col-md-8">
                <div class="report-container">
                    <div class="page-header">
                        <h4 class="page-title">
                            <i class="bi bi-bar-chart-line"></i>
                            Monthly Report
                        </h4>
                    </div>

                    <ShareLink ref="shareLink" :shareUrl="customUrl" :shareText="customShareText" />

                    <!-- Filter Card -->
                    <div class="filter-card">
                        <div class="filter-row">
                            <div class="filter-item">
                                <label for="monthSelect">Month</label>
                                <select id="monthSelect" class="form-select" v-model="month" @change="handleSelectionChange">
                                    <option value="1">January</option>
                                    <option value="2">February</option>
                                    <option value="3">March</option>
                                    <option value="4">April</option>
                                    <option value="5">May</option>
                                    <option value="6">June</option>
                                    <option value="7">July</option>
                                    <option value="8">August</option>
                                    <option value="9">September</option>
                                    <option value="10">October</option>
                                    <option value="11">November</option>
                                    <option value="12">December</option>
                                </select>
                            </div>
                            <div class="filter-item">
                                <label for="yearSelect">Year</label>
                                <select id="yearSelect" class="form-select" v-model="year" @change="handleSelectionChange">
                                    <option v-for="y in years" :value="y" :key="y">{{ y }}</option>
                                </select>
                            </div>
                            <div class="filter-actions">
                                <button class="btn btn-primary" @click="getReport()">
                                    <i class="bi bi-search"></i>
                                    <span>Get Report</span>
                                </button>
                                <button class="btn btn-outline-primary" @click="getShareReport()" v-if="data.plAfterTax && share">
                                    <i class="bi bi-share"></i>
                                    <span>Share</span>
                                </button>
                            </div>
                        </div>
                        <p class="error-msg" v-if="errorMsg">{{ errorMsg }}</p>
                    </div>

                    <DailyPosReport v-if="$store.state.dailyPosReport" :posData="posData"></DailyPosReport>

                    <!-- Results Section -->
                    <div class="results-section" v-if="data.plAfterTax">
                        <!-- P&L Stats -->
                        <div class="section-header">
                            <i class="bi bi-graph-up-arrow"></i>
                            <h5>P&L Stats</h5>
                        </div>
                        <div class="stats-grid">
                            <div class="stat-card" :class="data.plAfterTax >= 0 ? 'positive' : 'negative'">
                                <div class="stat-label">PAT</div>
                                <div class="stat-value">&#8377; {{ data.plAfterTax.toLocaleString('en-IN') }}</div>
                                <div class="stat-subtitle">Profit After Tax</div>
                            </div>
                            <div class="stat-card" :class="data.plBeforeTax >= 0 ? 'positive' : 'negative'">
                                <div class="stat-label">PBT</div>
                                <div class="stat-value">&#8377; {{ data.plBeforeTax.toLocaleString('en-IN') }}</div>
                                <div class="stat-subtitle">Profit Before Tax</div>
                            </div>
                            <div class="stat-card expense">
                                <div class="stat-label">TAX</div>
                                <div class="stat-value">&#8377; {{ data.tax.toLocaleString('en-IN') }}</div>
                                <div class="stat-subtitle">Tax Deducted</div>
                            </div>
                            <div class="stat-card expense">
                                <div class="stat-label">BROKER</div>
                                <div class="stat-value">&#8377; {{ data.brokerage.toLocaleString('en-IN') }}</div>
                                <div class="stat-subtitle">Brokerage Paid</div>
                            </div>
                        </div>

                        <!-- Daily P&L -->
                        <div class="section-header">
                            <i class="bi bi-calendar3"></i>
                            <h5>Daily P&L</h5>
                        </div>
                        <div class="daily-grid">
                            <div class="daily-card" v-for="(x, index) in data.reportDayList" :key="index"
                                 @click="getDailyPosReport(x.day, x.pl)"
                                 :class="x.pl >= 0 ? 'positive' : 'negative'">
                                <div class="daily-date">{{ new Date(x.day).toLocaleDateString("en-IN", { month: "short", day: "numeric" }) }}</div>
                                <div class="daily-value">&#8377; {{ x.pl.toLocaleString('en-IN') }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DailyPosReport from '@/components/report/DailyPosReport.vue'
import NavBar from '@/components/main/NavBar.vue'
import MarketWatch from '@/components/marketwatch/MarketWatch'
import { getReport, getMonthlyShareLink } from '@/service/restService'
import ShareLink from '@/components/report/ShareLink.vue'

export default {
  name: 'Report',
  components: {
    NavBar,
    MarketWatch,
    DailyPosReport,
    ShareLink
  },
  data () {
    return {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      data: {},
      errorMsg: '',
      showDailyReport: false,
      posData: {},
      customUrl: 'https://example.com/my-page',
      customShareText: 'Shared Monthly Report',
      share: false
    }
  },
  created () {
  },
  methods: {
    handleSelectionChange () {
      // Add your logic here
      this.share = false
    },
    getReport: function () {
      this.errorMsg = ''
      getReport(this.month, this.year).then((response) => {
        this.data = response.data
        this.share = true
        this.triggerAndroidFunction('REVIEW')
      }).catch((error) => {
        this.data = {}
        this.errorMsg = error.response.data.message[0]
      })
    },
    getShareReport: function () {
      this.errorMsg = ''
      getMonthlyShareLink(this.month, this.year).then((response) => {
        console.log(response.data)
        this.customUrl = response.data.url
        this.$refs.shareLink.openShareModal()
      }).catch((error) => {
        console.log('error' + error)
        this.errorMsg = error.response.data.message[0]
      })
    },
    getDailyPosReport: function (date, pl) {
      this.posData = {'date': date, 'pl': pl}
      this.$store.commit('dailyPosReport', true)
    }
  },
  computed: {
    years () {
      const year = new Date().getFullYear()
      return Array.from({ length: year - 2023 }, (value, index) => 2024 + index)
    }
  }
}
</script>
<style scoped>
.report-container {
    padding: 20px;
    max-width: 900px;
}

.page-header {
    margin-bottom: 20px;
}

.page-title {
    font-weight: 600;
    color: var(--bs-body-color);
    margin: 0;
    display: flex;
    align-items: center;
    gap: 10px;
}

.page-title i {
    color: var(--bs-primary);
}

/* Filter Card */
.filter-card {
    background: var(--bs-body-bg);
    border: 1px solid var(--bs-border-color);
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.filter-row {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    align-items: flex-end;
}

.filter-item {
    flex: 1;
    min-width: 120px;
}

.filter-item label {
    display: block;
    font-size: 13px;
    font-weight: 500;
    color: var(--bs-secondary-color);
    margin-bottom: 6px;
}

.filter-item .form-select {
    border-radius: 8px;
    border: 1px solid var(--bs-border-color);
    background-color: var(--bs-body-bg);
    color: var(--bs-body-color);
}

.filter-actions {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.filter-actions .btn {
    display: flex;
    align-items: center;
    gap: 6px;
    border-radius: 8px;
    padding: 8px 16px;
}

.error-msg {
    color: #dc3545;
    margin-top: 12px;
    margin-bottom: 0;
    font-size: 14px;
}

/* Results Section */
.results-section {
    margin-top: 20px;
}

.section-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid var(--bs-border-color);
}

.section-header i {
    font-size: 18px;
    color: var(--bs-primary);
}

.section-header h5 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: var(--bs-body-color);
}

/* Stats Grid */
.stats-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    margin-bottom: 24px;
}

.stat-card {
    background: var(--bs-body-bg);
    border: 1px solid var(--bs-border-color);
    border-radius: 12px;
    padding: 16px;
    text-align: center;
    transition: transform 0.2s, box-shadow 0.2s;
}

.stat-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.stat-card.positive {
    border-left: 4px solid #0BDA51;
}

.stat-card.negative {
    border-left: 4px solid #dc3545;
}

.stat-card.expense {
    border-left: 4px solid #ffc107;
}

.stat-label {
    font-size: 12px;
    font-weight: 600;
    color: var(--bs-secondary-color);
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.stat-value {
    font-size: 20px;
    font-weight: 700;
    margin: 8px 0 4px;
}

.stat-card.positive .stat-value {
    color: #0BDA51;
}

.stat-card.negative .stat-value {
    color: #dc3545;
}

.stat-card.expense .stat-value {
    color: #ffc107;
}

.stat-subtitle {
    font-size: 11px;
    color: var(--bs-secondary-color);
}

/* Daily Grid */
.daily-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 10px;
}

.daily-card {
    background: var(--bs-body-bg);
    border: 1px solid var(--bs-border-color);
    border-radius: 10px;
    padding: 12px;
    text-align: center;
    cursor: pointer;
    transition: transform 0.2s, box-shadow 0.2s;
}

.daily-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.daily-card.positive {
    border-bottom: 3px solid #0BDA51;
}

.daily-card.negative {
    border-bottom: 3px solid #dc3545;
}

.daily-date {
    font-size: 12px;
    font-weight: 500;
    color: var(--bs-secondary-color);
    margin-bottom: 4px;
}

.daily-value {
    font-size: 14px;
    font-weight: 600;
}

.daily-card.positive .daily-value {
    color: #0BDA51;
}

.daily-card.negative .daily-value {
    color: #dc3545;
}

/* Mobile Responsive */
@media (max-width: 768px) {
    .report-container {
        padding: 15px;
    }

    .filter-row {
        flex-direction: column;
    }

    .filter-item {
        width: 100%;
    }

    .filter-actions {
        width: 100%;
    }

    .filter-actions .btn {
        flex: 1;
        justify-content: center;
    }

    .stats-grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .stat-value {
        font-size: 16px;
    }

    .daily-grid {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (min-width: 992px) {
    .stats-grid {
        grid-template-columns: repeat(4, 1fr);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/report/Report.vue